<template>
    <div class="row">
        <div class="col-md-12">
            <div class="white-background p-25px border-radius preview-form">
                <b-form class="step-form">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="row">
                                <div
                                    v-for="(field, index) in formData"
                                    :key="index"
                                    :class="[
                                        field.type == 'heading'
                                            ? 'col-lg-12'
                                            : 'col-md-4',
                                    ]"
                                >
                                    <div
                                        v-if="
                                            field.type == 'heading' && index > 0
                                        "
                                        class="form-border"
                                    ></div>

                                    <component
                                        :is="field.type"
                                        :field="field"
                                        :data-segment-id="dataSegmentId"
                                    ></component>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-form>
            </div>

            <!-- When data is loading -->
            <base-table-spinner
                v-if="formData.length == 0 && showPageLoader"
            ></base-table-spinner>

            <base-no-record-found
                v-if="formData.length == 0 && !showPageLoader"
            ></base-no-record-found>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Heading from '@/components/form-builder/Heading.vue'
import TextField from '@/components/form-builder/TextField.vue'
import TextArea from '@/components/form-builder/TextArea.vue'
import DatePicker from '@/components/form-builder/DatePicker.vue'
import List from '@/components/form-builder/List.vue'
import Dropdown from '@/components/form-builder/Dropdown.vue'
import Radio from '@/components/form-builder/RadioButton.vue'
import Checkbox from '@/components/form-builder/Checkbox.vue'
import MultiSelect from '@/components/form-builder/MultiSelect.vue'
import PhoneNumber from '@/components/form-builder/PhoneNumber.vue'
import IdentityType from '@/components/form-builder/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/form-builder/IdentityDocumentExpiry.vue'
import Nationality from '@/components/form-builder/Nationality.vue'
import Country from '@/components/registration/Country.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'
import TaxId from '@/components/registration/TaxId.vue'

export default {
    components: {
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        MultiSelect,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Nationality,
        Country,
        WorkType,
        Industry,
        TaxId,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    data() {
        return {
            showPageLoader: false,
            formData: [],
        }
    },

    methods: {
        async getPreviewFormRecords() {
            this.formData = []
            let previewFormData = localStorage.getItem('previewFormData')
                ? JSON.parse(localStorage.getItem('previewFormData'))
                : []

            if (previewFormData.length > 0) {
                for (var i = 0; i < previewFormData.length; i++) {
                    if (
                        previewFormData[i].dataSegmentId == this.dataSegmentId
                    ) {
                        this.formData.push(previewFormData[i])
                    }
                }
            }
            this.$store.commit('initDefaultFields', 'form')
        },
    },

    computed: {
        ...mapGetters(['dataSegmentId']),
    },

    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getPreviewFormRecords()
            }
        },
    },

    mounted() {
        this.getPreviewFormRecords()
    },
}
</script>
